import React from 'react';
import Button from '../../../Shared/Button/Button';
import config from '../../../../config/config';
import './RMDModal.scss';

const RMDModal = ({
  closeModal,
  customerWebViewEnabled,
  isSalesforceRepEnabled,
}) => {
  return (
    <div className="rmd-modal">
      <section className="rmd-modal-main">
        <h2 className="rmd-modal-heading">Required Minimum Distribution</h2>
        <div className="rmd-modal-body">
          <p>
            You are required to take an RMD from your IRA for this year and the
            RMD must be satisfied prior to any Roth IRA conversions.
            {!(!customerWebViewEnabled && isSalesforceRepEnabled) && (
              <span>
                {' '}
                If you need assistance, please{' '}
                <a
                  href="https://www.troweprice.com/personal-investing/help/contact/index.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  contact us
                </a>
                .
              </span>
            )}
          </p>
          <p className="rmd-modal-bold">
            {!customerWebViewEnabled && isSalesforceRepEnabled ? (
              <span>
                By proceeding, you certify that you have satisfied your current
                year RMD.
              </span>
            ) : (
              <span>
                By clicking “I understand” you certify that you have satisfied
                your current year RMD and take full responsibility for complying
                with this requirement.
              </span>
            )}
          </p>
        </div>
      </section>
      <div className="rmd-modal-button-container">
        <a href={`${config.url}/usis/my-accounts/dashboard`}>Exit</a>
        <Button
          id="exchange-change-amount-btn"
          buttonType="primary"
          onClick={() => {
            closeModal();
          }}
        >
          I understand
        </Button>
      </div>
    </div>
  );
};

export default RMDModal;
